module.exports = __webpack_public_path__ + "media/images/flags/1x1/col-b06199938cd070730ab97608e650f1be.svg";